import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "register-container" }
const _hoisted_2 = { class: "container px-5 py-5 mt-5" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "register-div shadow-sm p-3 w-50 mx-auto" }
const _hoisted_5 = { class: "text-center mb-4" }
const _hoisted_6 = { class: "register-group d-flex flex-column px-5" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "form-group w-100 mb-3" }
const _hoisted_9 = { for: "name" }
const _hoisted_10 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_11 = { class: "form-group w-100 mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "E-mail", -1)
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_14 = { class: "form-group w-100" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "cpf" }, "CPF", -1)
const _hoisted_16 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_17 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_ds_button = _resolveComponent("ds-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "mb-5 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
        src: require('@/assets/images/logo_iosi_blue.png')
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("register.title")), 1),
        _createElementVNode("form", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("register.name")), 1),
              _createVNode(_component_InputText, {
                modelValue: _ctx.user.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.name) = $event)),
                id: "name",
                class: "form-control",
                "aria-placeholder": _ctx.$t('register.namePlaceholder'),
                name: "name",
                placeholder: _ctx.$t('register.namePlaceholder')
              }, null, 8, ["modelValue", "aria-placeholder", "placeholder"]),
              (_ctx.v$.user.name.$error)
                ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_InputText, {
                modelValue: _ctx.user.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.email) = $event)),
                id: "email",
                class: "form-control",
                name: "email",
                placeholder: "example@email.com",
                type: "email"
              }, null, 8, ["modelValue"]),
              (_ctx.v$.user.email.$error)
                ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_InputMask, {
                modelValue: _ctx.user.cpf,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.cpf) = $event)),
                id: "cpf",
                class: "form-control",
                "aria-placeholder": "000.000.000-00",
                mask: "999.999.999-99",
                name: "cpf",
                placeholder: "000.000.000-00"
              }, null, 8, ["modelValue"]),
              (_ctx.v$.user.cpf.$error)
                ? (_openBlock(), _createElementBlock("small", _hoisted_16, _toDisplayString(_ctx.$t("utils.mandatory")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_17, [
              _createTextVNode(_toDisplayString(_ctx.$t("menu.hasAccount")) + " ", 1),
              _createElementVNode("b", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.login())),
                class: "cursor-pointer"
              }, "Login")
            ]),
            _createVNode(_component_ds_button, {
              text: _ctx.$t('utils.register'),
              disabled: _ctx.disabledButton,
              onClick: _ctx.sendRegister,
              class: "mt-4 w-25 float-end",
              type: "primary"
            }, null, 8, ["text", "disabled", "onClick"])
          ])
        ])
      ])
    ])
  ]))
}